/* eslint-disable */
import React from "react";
import "../../styles/ComponentsStyles/Universal/FormInput.style.css";
import PropTypes from "prop-types";
import { Field, ErrorMessage } from "formik";
const FormInput = ({
  type,
  name = "test",
  label,
  placeholder,
  touched,
  errors,
  className,
  containerClass,
}) => {
  return (
    <div className={`modalFormInputContainer ${containerClass}`}>
      <label htmlFor={name}>{label}</label>
      {type !== "textarea" && (
        <Field
          type={type}
          placeholder={placeholder}
          name={name}
          className={`modalFormInput ${className} ${
            touched?.[name] && errors?.[name] ? "input-error" : ""
          }`}
        />
      )}
      {type === "textarea" && (
        <Field
          type={type}
          placeholder={placeholder}
          name={name}
          as={textareaInput}
          className={`modalFormInput ${className} ${
            touched?.[name] && errors?.[name] ? "input-error" : ""
          }`}
        />
      )}
      <ErrorMessage name={name} component="div" className="textInputError" />
    </div>
  );
};

FormInput.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
};

export default FormInput;

const textareaInput = (props) => (
  <textarea className="textareaClass" type="text" {...props}></textarea>
);
